import React from 'react';
import { Layout, Seo } from '@layout';
import { ECardsStorefrontPageContent } from '@components/storefront/ECardsStorefrontPageContent/ECardsStorefrontPageContent';
import { ECardCategorySlug, invitationDesignsCanonicalUrl, saveTheDateDesignsCanonicalUrl } from '@utils/storefront.util';
import { eCardDesignsPageData } from '@data-ts/templates/ecard-designs-page';
import { eCardsStorefrontPageContentData } from '@data-ts/components/storefront/ECardsStorefrontPageContent';

interface Props {
  pageContext: {
    cards: ReadonlyArray<StorefrontECard>;
    productType: ShopifyProductType;
    categorySlug: ECardCategorySlug;
  };
}

const { seo } = eCardDesignsPageData;

const ECardDesignsPageTemplate = ({ pageContext: { cards, productType, categorySlug } }: Props) => {
  const parentPage = productType === 'Invitation' ? 'wedding-invitations-designs' : 'save-the-date-designs';
  const baseCanonicalUrl = productType === 'Invitation' ? invitationDesignsCanonicalUrl : saveTheDateDesignsCanonicalUrl;
  const seoCategoryLabel = eCardsStorefrontPageContentData.categories[categorySlug].replace('&', 'and');
  const seoTitle = `${seoCategoryLabel} ${seo.titleProductType[productType]} ${seo.titleSuffix}`;
  const seoDescription = `${seoCategoryLabel} ${seo.titleProductType[productType]} ${seo.descriptionSuffix}`;
  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="purple6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      page={parentPage}
    >
      <Seo title={seoTitle} description={seoDescription} canonicalURL={`${baseCanonicalUrl}${categorySlug}`} />
      <ECardsStorefrontPageContent productType={productType} cards={cards} initialCategorySlug={categorySlug} />
    </Layout>
  );
};

export default ECardDesignsPageTemplate;
